import React from 'react';
import { StarIcon } from 'lucide-react';
import { GOOGLE_REVIEWS_URL } from '../data/reviews';
export function GoogleGlyph({
  className = 'h-4 w-4'
}: {
  className?: string;
}) {
  return <svg viewBox="0 0 48 48" className={className} aria-hidden="true" focusable="false" data-id="element-61" data-mp="155fg3zd8fl3a">
      <path fill="#4285F4" d="M45.1 24.5c0-1.6-.1-2.8-.4-4H24v7.3h12.1c-.2 2-1.6 5-4.5 7l6.9 5.3c4.1-3.8 6.6-9.4 6.6-15.6z" data-id="element-62" data-mp="106kyh0r042kr" />
      <path fill="#34A853" d="M24 46c5.9 0 10.9-2 14.5-5.3l-6.9-5.3c-1.9 1.3-4.4 2.2-7.6 2.2-5.8 0-10.7-3.8-12.5-9.1l-7.1 5.5C8.1 41.1 15.4 46 24 46z" data-id="element-63" data-mp="chtf8yve2uk4" />
      <path fill="#FBBC05" d="M11.5 28.5c-.5-1.4-.7-2.9-.7-4.5s.3-3.1.7-4.5l-7.1-5.5C2.9 16.9 2 20.3 2 24s.9 7.1 2.4 10l7.1-5.5z" data-id="element-64" data-mp="m735saal4564" />
      <path fill="#EA4335" d="M24 10.6c3.3 0 5.5 1.4 6.8 2.6l6.1-6C33.1 3.9 29.1 2 24 2 15.4 2 8.1 6.9 4.4 14l7.1 5.5c1.8-5.3 6.7-8.9 12.5-8.9z" data-id="element-65" data-mp="he0bfzxzgrov" />
    </svg>;
}
function Stars({
  className = 'h-3.5 w-3.5'
}: {
  className?: string;
}) {
  return <span className="flex items-center gap-0.5" aria-hidden="true" data-id="element-66" data-mp="h7cwt5w7zn9z">
      {Array.from({
      length: 5
    }).map((_, i) => <StarIcon key={i} className={`${className} fill-gold text-gold`} strokeWidth={0} data-id="element-67" data-mp="m5eh1u5dtsn1" data-mpi={i} />)}
    </span>;
}
interface GoogleRatingProps {
  analyticsId: string;
  className?: string;
}

/** Insignia flotante de confianza: tarjeta blanca, borde lavanda fino y sombra suave. */
export function GoogleRating({
  analyticsId,
  className = ''
}: GoogleRatingProps) {
  return <a href={GOOGLE_REVIEWS_URL} target="_blank" rel="noopener noreferrer" data-analytics-id={analyticsId} aria-label="5.0 estrellas en Google con 8 reseñas verificadas. Abre las reseñas en una pestaña nueva." className={`group inline-flex items-center gap-3 rounded-pill border border-lavender-200 bg-ivory px-4 py-2.5 shadow-soft transition-[box-shadow,transform,border-color] duration-200 ease-premium hover:-translate-y-[1px] hover:border-lavender-300 hover:shadow-float focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-plum-700 ${className}`} data-id="element-68" data-mp="39674d1fctle">
      <GoogleGlyph className="h-[18px] w-[18px]" data-id="element-69" data-mp="3fs3za2bbapir" />
      <span className="h-5 w-px bg-lavender-200" aria-hidden="true" data-id="element-70" data-mp="3tohgdabxoowp" />
      <span className="flex flex-col leading-tight" data-id="element-71" data-mp="3oqpj00sisal4">
        <span className="flex items-center gap-2" data-id="element-72" data-mp="3or8xt8mviiux">
          <Stars data-id="element-73" data-mp="310dc8t90gjw4" />
          <span className="text-[0.9rem] font-semibold text-plum-900" data-id="element-74" data-mp="311wrqhmueqwu">5.0</span>
        </span>
        <span className="mt-0.5 text-[0.7rem] text-muted" data-id="element-75" data-mp="2x0b90fnmnieq">8 reseñas verificadas</span>
      </span>
    </a>;
}
export { Stars as GoogleStars };